<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.content">
      <div
        class="cancelSign"
        @click="cancelSign(questionData)"
        v-if="questionData.form && questionData.form.is_sign == '1'"
      >
        <img src="../../../../assets/cancelSign.png" alt="" />
        <span>取消标记</span>
      </div>
      <div class="addSign" @click="addSign(questionData)" v-else>
        <img src="../../../../assets/addSign.png" alt="" />
        <span>标记此题</span>
      </div>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <div class="title">
          「多选题」<span class="score" v-if="questionData.data.score"
            >{{ questionData.data.score }}分</span
          >
        </div>
        <!-- 试题附件展示组件 -->
        <question-files
          v-if="questionData.data.attachment"
          :attachment="questionData.data.attachment"
        ></question-files>
        <span class="questionName"
          >{{ questionData.data.num }}、<span
            v-html="questionData.data.content"
          ></span
        ></span>
      </div>
      <ul class="checkboxContent">
        <a-checkbox-group @change="onChange" v-model="value" class="selete">
          <li v-for="(item, index) in questionData.data.items" :key="item.id">
            <a-checkbox :value="item.id">
              {{ String.fromCharCode(index + 65) }}、<span
                v-html="item.content"
              ></span>
            </a-checkbox>
          </li>
        </a-checkbox-group>
      </ul>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.data.num }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
export default {
  name: "checkbox",
  components: { QuestionFiles },
  props: ["questionData"],
  data() {
    return {
      value: [],
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
    };
  },
  mounted () {
    let arr =  this.questionData.form.answer.split(",")
    if(arr && arr.length > 0 ){
      arr.forEach(element => {
        this.value.push(Number(element))
      });
    }
  },
  methods: {
    onChange(val) {
      let arr = this.value;
      arr.push.apply(arr, val);
      arr = arr.sort();
      let arr1 = new Set(arr);
      this.value = Array.from(arr1);
      this.questionData.form.answer = this.value.join(",");
    },
    //取消标记
    cancelSign(val) {
      val.form.is_sign = "2";
      this.$forceUpdate();
    },
    //标记此题
    addSign(val) {
      val.form.is_sign = "1";
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  position: absolute;
  top: 35px;
  right: 50px;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.cancelSign {
  float: right;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.cancelSign span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f79e3f;
  line-height: 32px;
}
.addSign {
  float: right;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.addSign span {
  width: 57px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 32px;
}
.question .title {
  width: 371px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  width: 92px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  width: 100%;
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
  /deep/ol {
    list-style: decimal;
    margin-left: 15px;
  }
}
li {
  margin-bottom: 10px;
  height: auto;
}
ul {
  margin-top: 10px;
}
li img {
  display: block;
  height: 110px;
  margin-top: 10px;
}
/deep/.selete ul,
/deep/.selete ol {
  display: inline-block;
}
/deep/.checkboxContent img {
  max-width: 90% !important;
  display: block;
  margin-top: 5px;
}
/deep/.checkboxContent p {
  display: inline;
}
.checkboxContent {
  word-wrap: break-word;
  word-break: normal;
}
.score {
  color: #9a3bec;
  font-weight: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
</style>